import React, { useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';

/** Keep native date pickers, with a visible prompt on phones that leave them blank. */
const CustomDateFields = ({ value, onChange, constrainRange = false }) => {
    const id = useId();
    return (
        <div className="custom-date-filters fade-in" role="group" aria-label="Custom date range">
            {[
                { key: 'from', label: 'From', max: constrainRange ? value.to || undefined : undefined },
                { key: 'to', label: 'To', min: constrainRange ? value.from || undefined : undefined }
            ].map(({ key, label, min, max }) => (
                <div className="date-input-group" key={key}>
                    <label className="date-label" htmlFor={`${id}-${key}`}>{label}</label>
                    <span className="custom-date-input">
                        <input
                            id={`${id}-${key}`}
                            type="date"
                            className="date-picker-small"
                            value={value[key]}
                            min={min}
                            max={max}
                            data-empty={!value[key]}
                            onChange={event => onChange({ ...value, [key]: event.target.value })}
                        />
                        {!value[key] && <span className="custom-date-placeholder" aria-hidden="true">Select date <FontAwesomeIcon icon={faCalendarDay} /></span>}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default CustomDateFields;
